import type { IBodyItem, IHtmlArchiveBlock } from "~/feature/insights/types";

export const getFullPageArchive = (
  body: IBodyItem[] | null | undefined
): IHtmlArchiveBlock | null =>
  body?.find(
    (block): block is IHtmlArchiveBlock =>
      block._type === "htmlArchiveEmbed" && block.displayMode === "fullPage"
  ) ?? null;
